import { Box, Button, TextField, useMediaQuery, useTheme } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useSelector } from "react-redux";
import { requester } from "api/pesabackend";

const DeductionTypeSchema = yup.object().shape({
  deduction_name: yup.string().required("required"),
});

const initialValuesDeductionType = {
  deduction_name: "",
};

const DeductionTypeForm = (props) => {
  const pageType = props.formType;
  let { editData } = props;
  const userId = useSelector((state) => state.authReducer.user.userId);
  const business_id = useSelector((state) => state.authReducer.business_id);
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const { palette } = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const isNew = pageType === "create";
  const isEdit = pageType === "edit";

  const initialEditValuesDeductionType = {
    deduction_name: editData.deduction_name,
  };

  const saveDeductionType = async (values, onSubmitProps) => {
    values.related_business = business_id;
    values.related_business_branch = business_branch_id;
    values.added_by = userId;

    const savedResponse = await requester.post(`/human_resource/deduction`, JSON.stringify(values));
    
    if (savedResponse.data.status === 201) {
      onSubmitProps.resetForm();
      props.setIsSuccess(true);
      props.setNewDeductionTypeData(true);
      props.setOpen(false);
    }
  };

  const editDeductionType = async (values, onSubmitProps) => {
    const savedResponse = await requester.post(`/human_resource/deduction/edit/${editData.id}`, JSON.stringify(values));
    
    if (savedResponse.data.status === 201) {
      onSubmitProps.resetForm();
      props.setIsSuccess(true);
      props.setNewDeductionTypeData(true);
      props.setOpen(false);
    }
  };

  const handleFormSubmit = async (values, onSubmitProps) => {
    if (isNew) await saveDeductionType(values, onSubmitProps);
    if (isEdit) await editDeductionType(values, onSubmitProps);
  };

  return (
    <Formik
      onSubmit={handleFormSubmit}
      initialValues={isNew ? initialValuesDeductionType : initialEditValuesDeductionType}
      validationSchema={DeductionTypeSchema}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
      isSubmitting,
      }) => (
        <form onSubmit={handleSubmit}>
          <Box
            display="grid"
            gap="30px"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            sx={{
              "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
            }}
          >
            <TextField
              label="Deduction Type Name"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.deduction_name}
              name="deduction_name"
              error={Boolean(touched.deduction_name) && Boolean(errors.deduction_name)}
              helperText={touched.deduction_name && errors.deduction_name}
              sx={{ gridColumn: "span 4" }}
            />
          </Box>

          {/* BUTTONS */}
          <Box>
            <Button
              fullWidth
              type="submit"
              disabled={isSubmitting}
              sx={{
                m: "1rem 0",
                p: "1rem",
                backgroundColor: palette.primary.main,
                color: palette.background.alt,
                "&:hover": { color: palette.primary.main },
              }}
            >
              Save
            </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default DeductionTypeForm;
